<template>
    <div class="faq">
        <div
            ref="collapsible"
            v-on:click="toggleCollapse"
            class="collapsible"
        >
            <img
                v-cloak
                src="../assets/images/faq-question-icon.svg"
                title="FAQ question"
                alt="Question symbol"
            >
            <strong v-text="question" />
        </div>
        <div class="content">
            <p><slot /></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Faq',
    props: {
        question: {
            type: String,
            required: true,
        }
    },
    methods: {
        toggleCollapse: function toggleCollapse () {
            let el = this.$refs.collapsible;
            let content = el.nextElementSibling;
            el.classList.toggle("active");
            content.style.maxHeight = content.style.maxHeight
                ? null
                : content.scrollHeight + "px";
        },
    },
};
</script>

<style lang="scss" scoped>
.faq {
    .collapsible {
        max-width: 980px;
        background-color: #fff;
        color: #577E5E;
        cursor: pointer;
        padding: 18px;
        width: 100%;
        border: none;
        text-align: left;
        outline: none;
        font-size: 16px;
        margin: 1rem auto 0rem;
        position: relative;
        padding: 14px 15px 12px 35px;
        font-weight: normal;
        border-radius: 5px;

        img {
            position: absolute;
            left: -8px;
            top: -5px;
        }
    }

    .active {
        -webkit-border-bottom-left-radius: 0px;
        -moz-border-radius-bottomright: 0px;
        -moz-border-radius-bottomleft: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
    }

    .active, .collapsible:hover {
        background-color:#40695A;
        color: #fff;
        cursor: pointer;
    }

    .content {
        max-width:980px;
        padding: 0 18px;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.2s ease-out;
        background-color: #f1f1f1;
        color: #77787A;
        text-align:left;
        margin: 0 auto;
        background-color:#40695A;
        color: #fff;
        -webkit-border-bottom-right-radius: 5px;
        -webkit-border-bottom-left-radius: 5px;
        -moz-border-radius-bottomright: 5px;
        -moz-border-radius-bottomleft: 5px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        padding-left: 35px;
        padding-right: 35px;
    }

    a {
        color: #fff;
        text-decoration:underline;
    }

    p {
        margin-bottom:20px;
    }
}
</style>